const gridUnitSize = 20;

const breakpoints = {
  sm: '1030px',
  md: '1300px',
  lg: '1550px',
};

const theme = {
  colors: {
    selectableLightBg: '#156777',
    selectableDarkBg: '#1A808E',
    selectableRollover: '#0b464f',
    selected: '#CBDDE1',
    notSelectable: '#8EAEB2',
    tabBackground: '#B6BFBB',
    placeholderText: '#B4B4B4',
    tabInactive: '#F2F2F2',
    buttonDisabled: '#C5C5C5',
    buttonDisabledBg: '#E9EBEA',
    accentButton: '#DB634B',
    accentButtonRollover: '#B24842',
    accentText: '#5B0C0A',
    text: '#555555',
    disabledText: '#ADADAD',
    mutedText: '#8EADB1',
    toolbar: '#332D2F',
    modules: '#F7F7F7',
    rowStripe: '#FBFBFB',
    alert: '#2BC3EA',
    error: '#FF2929',
    white: '#FFFFFF',
    black: '#231F20',
    transparent: 'rgba(0,0,0,0)',
    avatarBgDark: '#94ACB0',
    productTitle: '#5B0A09',
    entryModalBg: '#ecedef',
    moon: '#bacccc',

    cloudGreyFont: '#58585a',
    redAccentButton: '#db3f35',
    tealLight: '#8db2b9',
    tealLighter: '#76a0a8',
    lightGreyBackground: '#dbdbdb',
    cloudFontGreen: '#25928d',

    cloudGreen: '#90c7b0',
    cloudBlue: '#2ac2e9',
    cloudTeal: '#146878',
    flowjoBlue: '#034873',

    cloudFontGreenTeal: '#1c928e',
    borderLightTeal: '#8db3bb',
    cloudCharcoalFont: '#666',
    cloudGreenFont: '#3cbca0',
    defaultWhiteFont: '#fff',
    cloudBlackFont: '#231f20',

    alertRed: '#dd6346',
    successGreen: '#2a9606',

    defaultDarkBackgroundColor: '#231f20',
    darkGreyBackground: '#58585a',
    defaultLightBackgroundColor: '#fbfbfb',
    defaultGreyBorderColor: '#a6a19c',
    defaultBoxBackgroundColor: '#ecedef',
    defaultFieldFont: '#ccc',

    adminToolButtonSelect: '#8cb2ba',

    tealSelectable: '#156777',
    tealSelected: '#cbdde1',
    tealDisabled: '#8eaeb2',
    grayDarkForeground: '#231f20',
    grayLightBackground: '#f7f7f7',
    brownLightAccent: '#bbb1a7',

    colorDefault: '#849fbb',
    colorDefaultLight: '#dddddd',
    colorActive: '#57cb85',
    colorActiveLight: '#9effc4',
    colorFocus: '#6fb5fb',

    sideNavIcons: {
      primaryColor: '#1a808e',
      bgColor: '#332e30',
      hover: {
        primaryColor: '#0f484c',
        bgColor: '#332e30',
      },
      active: {
        primaryColor: '#cbdde1',
        bgColor: '#4c4749',
      },
    },
  },
  gradients: {
    tabBackground: '#8EAEB2, #CBDDE1, #B6BFBB',
  },
  fontSizes: {
    p: '12px',
    h1: '26px',
    h2: '21px',
    h3: '18px',
    h4: '16px',
    h5: '14px',
    h6: '12px',
    buttonSmall: '12px',
    buttonLarge: '14px',
    sup: '10px',
    sidebarTitle: {
      default: '14px',
      small: '12px',
      large: '15px',
    },
  },
  fontWeights: {
    normal: '400',
    bold: '600',
  },
  fontFamilies: {
    default: "'Roboto', sans-serif",
  },
  borderRadius: '4px',
  grid: {
    units: (n: number): string => `${gridUnitSize * n}px`,
  },
  breakpoints,
  minWidth: (size: string): string =>
    `@media only screen and (min-width: ${breakpoints[size as keyof typeof breakpoints] || size})`,
};

export default theme;
